import Button from '../inputs/Button';

export default function CompletePurchaseButton({ disabled, onClick }) {
  return (
    <Button
      type="button"
      primary
      className="min-w-max"
      disabled={disabled}
      onClick={onClick}
    >
      Complete Order
    </Button>
  );
}
